import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { alert } from './alert.reducer';
import { activity } from './activity.reducer';
import { modal } from './modal.reducer';
import { api } from './api.reducer';
import { airlines } from './airline.reducer';
import { airlinesCarriers } from './airline_carrier.reducer';
import { desAirports } from './desAirport.reducer';
import { depAirports } from './depAirports.reducer';
import { countries } from './countries.reducer';
import { flightDays } from './flightDays.reducer';
import { invoice } from './invoice.reconciliation.reducer';
import { ftpCredentials } from './ftpCredentials.reducer';
import { users } from './user.reducer';
import { workFlowProcess } from './workFlowProcess.reducer';
import { entities } from './entityTypes.reducer';
import { airlineLocations } from './airlineLocations.reducer'
import { flagMetrics } from './flagMetrics.reducer';
import { ticketClass } from './ticketClass.reducer';
import { ticketCategory } from './ticketCategory.reducer';
import { dashboard } from "./dashboard.reducer";


const rootReducer = combineReducers({
    authentication,
    alert,
    modal,
    activity,
    api,
    airlines,
    airlinesCarriers,
    desAirports,
    depAirports,
    flightDays,
    countries,
    invoice,
    ftpCredentials,
    users,
    workFlowProcess,
    entities,
    airlineLocations,
    flagMetrics,
    ticketClass,
    ticketCategory,
    dashboard
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js